<template>
  <div class="expanded">
    <div class="expanded-row">
      <div class="centered-column">
        <div v-if="isSuccess" class="success">
          <div class="check"></div>
        </div>
        <div v-else class="fail">
          <div class="cross"></div>
          <div class="cross"></div>
        </div>

        <h3>
          {{ $t(isSuccess ? 'processEvent.voucher.message.success' : 'processEvent.voucher.message.failure') }}
        </h3>
        <h4 v-if="isSuccess">
          {{ $t('processEvent.voucher.message.success_extra', { amount, phoneNumber }) }}
        </h4>
      </div>
    </div>
    <div class="expanded-row">
      <button class="submit-order" type="button" @click="showVoucher">
        {{ $t(isSuccess ? 'processEvent.voucher.btn.success' : 'processEvent.voucher.btn.failure') }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import type { PropType } from 'vue';
import type { VoucherResponse } from '../types/vouchers';

export default defineComponent({
  name: 'VoucherSuccess',
  props: {
    isSuccess: {
      type: Boolean,
      default: false,
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    voucherSuccess: {
      type: Object as PropType<VoucherResponse | null>,
      default: null,
    },
  },
  emits: ['showVoucher'],
  setup(props, { emit }) {
    const showVoucher = () => emit('showVoucher');

    const amount = computed(() => {
      if (!props.voucherSuccess) return null;
      const locale = navigator.language;
      return new Intl.NumberFormat(locale || 'en-US', {
        style: 'currency',
        currency: props.voucherSuccess.currency,
      })
        .format(props.voucherSuccess.amount)
        .toUpperCase();
    });

    return {
      showVoucher,
      amount,
    };
  },
});
</script>

<style scoped lang="scss">
.expanded {
  margin-top: 8px;
}

.expanded-row {
  display: flex;
  flex-direction: column;
}

h3 {
  margin-top: 16px;
}

h4 {
  margin-top: 10px;
  color: gray;
}

.success {
  border-radius: 50%;
  width: 80px;
  height: 80px;
  overflow: hidden;
  background-color: green;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .check {
    width: 50px;
    height: 25px;
    border-left: 12px solid white;
    border-bottom: 12px solid white;
    transform: rotate(-45deg);
    margin-bottom: 10px;
    position: absolute;
  }
}

.fail {
  border-radius: 50%;
  width: 80px;
  height: 80px;
  overflow: hidden;
  background-color: red;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .cross {
    width: 16px;
    height: 50px;
    background: white;
    position: absolute;

    &:first-of-type {
      transform: rotate(45deg);
    }

    &:last-of-type {
      transform: rotate(-45deg);
    }
  }
}

.centered-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
